import "./overviewContentStyles.scss";
import LeftImage from "../../../BSUHeader/21_umc066_4065.jpg";
import RightImage from "../../../BSUHeader/ChemistryScholarship_3.jpg";


const OverviewContent = () => {
  return (
    <div className="overview-content">
      <div className="image-wrapper">
        <img
          className="img-left"
          src={LeftImage}
          alt="Mixing viles in a lab"
        />
      </div>
      <div className="image-wrapper-2">
        <img
          src={RightImage}
          className="img-right"
          alt="Pouring chemicals into a vile"
        />
      </div>
      <div className="left-content">
        <h2>What is I-ASCEND?</h2>
        <p>
          The I-ASCEND program provides scholarships to academically
           talented first-year students with financial need majoring in chemistry and biology and those wishing
           to enter the workforce or transfer to a graduate program upon BS degree completion.
        </p>
      </div>

      <div className="right-content">
        <h2>Who supports I-ASCEND?</h2>
        <p>
          This program has been made possible by a grant entitled
          "Pathways to STEM Degrees through <b>I</b>ntegrated <b>A</b>cademic <b>S</b>upport
          ,<b>C</b>areer <b>EN</b>hancement, and Personal <b>D</b>evelopment (<b>I-ASCEND</b>)"
          from the National Science Foundation to Ball State University.
        </p>
      </div>
    </div>
  );
};

export default OverviewContent;
